<script>
    import { createEventDispatcher } from "svelte";
    import ImageSelect from "./ImageSelect.svelte";
    import ImageUpload from "./ImageUpload.svelte";
    import DumbGalleryItem from "./DumbGalleryItem.svelte";
    
    export let images;
    export let selection;
    export let editable = true;
    export let imgSize = {
        x: 360,
        y: 360
    };
    const dispatch = createEventDispatcher();
    
    let newFile;

    function toggle(e) {
        dispatch("toggle", {
            image: e.detail.image
        })
    }

    function del(e) {
        dispatch("del", e.detail)
    }

    function fileSelected(e) {
        console.log("New image selected");
        newFile = e.detail.file;
    }

    function uploadFinished(e) {
        dispatch("uploadFinished", {
            src: e.detail.src,
            path: e.detail.path
        })
    }
</script>

{#if images}
    <div class="gallery">
        {#if newFile}
            <ImageUpload bind:file={newFile} on:uploadFinished={uploadFinished} bind:outputDimensions={imgSize}></ImageUpload>
        {/if}
        {#if editable}
            <ImageSelect on:select={fileSelected}/>
        {/if}
        {#each images as image (image.id)}
            <DumbGalleryItem selected={selection==image.src} bind:image={image} on:toggle={toggle} on:del={del} bind:editable/>
        {/each}
    </div>
{/if}

<style>
    .gallery {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(8, 1fr);
        justify-content: space-between;  
        gap: 0.5rem;
        margin-bottom: 1rem;
        margin-top: 1rem;
    }
</style>